import React, { useEffect, useState } from "react";
import { Flex, notification } from "antd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAdd, faEdit, faExclamationCircle, faTrash } from "@fortawesome/free-solid-svg-icons";
import {
  ArrowLeftOutlined,
} from "@ant-design/icons";

import { Link, useLocation } from "react-router-dom";
import UpdateStock from  './UpdateStock';

import {
  inventoryList,
  addEditInventoryData,
  deleteInventoryData,
  updateInventoryData,
  VariantList
} from "../../../../controllers/V1/products/productController";

import LoadingEffect from "../../../../components/Loading/LoadingEffect";

import "../product.css";
import SkeltonList from "../../../../components/SkeltonEffect/list";
import { faCheckCircle } from "@fortawesome/free-regular-svg-icons";
import { usePermissions } from "../../../../controllers/PermissionContext";
const AddEditInventoryData = () => {
  const PERMISSION = usePermissions("productInventory");
  const location = useLocation();
  const [ADDEDITDATA, setAddEditData] = useState(location?.state || {});
  const [pageType, setPageType] = useState(ADDEDITDATA?.pageType || 'Users');
  const [isLoading, setIsLoading] = useState(false);

  const [inventoryId, setInventoryId] = useState('');
  const [updateStock, setUpdateStock] = useState(false);
  const toggleUpdateStock = () => setUpdateStock(!updateStock);


  const [allVariantData, setAllVariantData] = useState([]);
  const [allInventoryData, setAllInventoryData] = useState([]);
  const [transformData, setTransformData] = useState([]);
  
  const getVariantData = async () => {
    try {
      setIsLoading(true);
      const option = {
        condition : { status : "A" },
        sort : {product : -1},
        limit : 0,
        skip : 0
      }
      const res = await VariantList(option);
      if(res.status) {
        setAllVariantData(res?.result || []);
        if(ADDEDITDATA?._id){
          const inventory = await getInventoryData(ADDEDITDATA?._id);
          await prepareListData(res?.result, inventory);
        }
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false); 
    }
  }

  const getInventoryData = async (user_id = '') => {
    try {
      setIsLoading(true);
      const option = {
        condition : { user_id : user_id, status : "A" },
        sort : {product : -1},
        limit : 0,
        skip : 0
      }
      const res = await inventoryList(option);
      if(res.status) {
        setAllInventoryData(res?.result || []);
        return res?.result || [];
      }
    } catch (error) {
      setIsLoading(false);
    }
  }

  const prepareListData = async (ariantData=[], inventoryData = []) => {
    try {
      if(ariantData.length > 0){
        const allData = await Promise.all(ariantData.map((items)=>{
          const data = inventoryData.filter((item)=>item.variant_id?._id === items?._id)
          return {
            _id           : items?._id,
            user_id       : ADDEDITDATA?._id,
            product_id    : items?.product._id,
            product_name  : items?.product?.name,
            unit          : items?.unit,
            price        : items?.price,
            ...(data?.length > 0 ? { 
              inventory_id : data[0]._id,
              stock : data[0].avl_qty,
              select        : 'Y'
             } : { 
              stock         : 0,
              select        : 'N'
             }),
          }
        }));
        setTransformData(allData);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.log('error',error);
    }
  }

  

  const handleAddInventory = async (items) =>{
    try {
      const params = {
        qty: 0,
        variant_id: items._id,
        product_id: items.product_id,
        user_id: ADDEDITDATA?._id,
        type : pageType || 'Users',
      };
      const res = await addEditInventoryData(params);
      if(res.status === true){
        getVariantData();
      }
    } catch (error) {
      
    }
  }


  const handleDeleteInventory = async (item_id) =>{
    try {
      const params = {
        id : item_id
      };
      const res = await deleteInventoryData(params);
      if(res.status === true){
        getVariantData();
      }
    } catch (error) {
      
    }
  }

  //Handle update Stock 
    const handleUpdateStock = async (item_id='', qty=0) => {
      try {
        if(item_id){
          setInventoryId(item_id);
          toggleUpdateStock();
        } else{
          const option = {
            id : inventoryId,
            qty : qty
          }
          const res = await updateInventoryData(option);
          if(res.status === true){
            getVariantData();
            notification.open({
              message: "Success",
              description: `Variant delete successfully..`,
              placement: "topRight",
              icon: (
                <FontAwesomeIcon
                  icon={faCheckCircle}
                  style={{ color: "green" }}
                />
              ),
              duration: 2,
            });
          } else{
            notification.open({
              message: "Oops!",
              description: `${res.message}`,
              placement: "topRight",
              icon: (
                <FontAwesomeIcon
                  icon={faExclamationCircle}
                  style={{ color: "red" }}
                />
              ),
              duration: 2,
            });
          }
          setInventoryId('');
        }
      } catch (error) {
        setInventoryId('');
      }
    }

    const handleAddAll = async () => {
      try {
        setIsLoading(true);
        const data = transformData.filter((item)=>item.select === 'N');
        for (const item of data) {
          const param = {
            qty: 0,
            variant_id: item._id,
            product_id: item.product_id,
            user_id: ADDEDITDATA?._id,
            type : pageType
          };
          await addEditInventoryData(param);
        }
        getVariantData();
      } catch (error) {
        setIsLoading(false);
      }
    }

  useEffect(() => {
    getVariantData();
    setAddEditData(location?.state || {});
    setPageType(ADDEDITDATA?.pageType || 'Users');
    document.title = `Orbit Kuwait || Manage ${pageType} Inventory`;
  }, []);

  const usersDetails = () => {
    return (
      <div className="row"> 
        <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <label label for="user" className="all_lable_for_vendor_dashbaord" ><span style={{ color: "red" }}>*</span> Name : {`${ADDEDITDATA?.users_name} ${ADDEDITDATA?.last_name}`}</label>
        </div>

        <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <label label for="user" className="all_lable_for_vendor_dashbaord" ><span style={{ color: "red" }}>*</span> Ph. Number : {`${ADDEDITDATA?.users_mobile}`}</label>
        </div>

        <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <label label for="user" className="all_lable_for_vendor_dashbaord" ><span style={{ color: "red" }}>*</span> POS Number : {`${ADDEDITDATA?.pos_number}`}</label>
        </div>

        <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <label label for="user" className="all_lable_for_vendor_dashbaord" ><span style={{ color: "red" }}>*</span> Area : {`${ADDEDITDATA?.area}`}</label>
        </div>
      <hr/>
      </div>
    )
  }

  const pickUpPointsDetails = () => {
    return (
      <div className="row"> 
        <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <label label for="user" className="all_lable_for_vendor_dashbaord" ><span style={{ color: "red" }}>*</span> Name : {`${ADDEDITDATA?.name}`}</label>
        </div>
        <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <label label for="user" className="all_lable_for_vendor_dashbaord" ><span style={{ color: "red" }}>*</span> Mobile : {`${ADDEDITDATA?.mobile}`}</label>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <label label for="user" className="all_lable_for_vendor_dashbaord" ><span style={{ color: "red" }}>*</span> Address : {`${ADDEDITDATA?.address}`}</label>
        </div>
      <hr/>
      </div>
    )
  }

  // console.log('ADDEDITDATA',ADDEDITDATA);
  return (
    <div>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          {pageType === 'Users' && (
            <React.Fragment>
              <h5 className="inventory_edit_page_heading"> {`${ADDEDITDATA?.users_name} (${ADDEDITDATA?.pos_number})`} Inventory </h5>
            </React.Fragment>
          )}
          {pageType === 'Pick Up Points' && (
            <React.Fragment>
              <h5 className="inventory_edit_page_heading"> {`${ADDEDITDATA?.name}`} Inventory </h5>
            </React.Fragment>
          )}
          <Link to={"/product/inventory/list"}>
            <React.Fragment>
              <button type="button" className="btn btn-secondary">
                {" "}
                <ArrowLeftOutlined /> Back{" "}
              </button>
            </React.Fragment>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form method="post" className="inventory_form_main_contnet" >
                <input type="hidden" name="user_id" id="user_id" value={ADDEDITDATA?.bind_person_id || ''}/>
                <input type="hidden" name="edit_id" id="edit_id" value={ADDEDITDATA?._id || ''}/>
                {/* <div className="row"> 
                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label label for="user" className="all_lable_for_vendor_dashbaord" ><span style={{ color: "red" }}>*</span> Name : {`${ADDEDITDATA?.users_name} ${ADDEDITDATA?.last_name}`}</label>
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label label for="user" className="all_lable_for_vendor_dashbaord" ><span style={{ color: "red" }}>*</span> Ph. Number : {`${ADDEDITDATA?.users_mobile}`}</label>
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label label for="user" className="all_lable_for_vendor_dashbaord" ><span style={{ color: "red" }}>*</span> POS Number : {`${ADDEDITDATA?.pos_number}`}</label>
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label label for="user" className="all_lable_for_vendor_dashbaord" ><span style={{ color: "red" }}>*</span> Area : {`${ADDEDITDATA?.area}`}</label>
                  </div>
                <hr/>
                </div> */}
                {pageType === 'Users' && (
                  usersDetails()
                )}
                {pageType === 'Pick Up Points' && (
                  pickUpPointsDetails()
                )}
                <div className="row">
                  {(PERMISSION?.fullAccess === 'Y' || PERMISSION?.addRemove === 'Y') && (
                    <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center mt-4">
                      <div className="verndor_dashboard_add_edit_button">
                        <button type="button" className="btn btn-primary inventory_save_button" onClick={handleAddAll}> Add all variant </button>
                      </div>
                    </div>
                  )}

                  <div id="content-wrapper" className="d-flex flex-column">
                    <div className="card shadow mb-4">
                      <div className="card-body pt-0">
                        <div className="table-responsive">
                          <table
                            className="table table-bordered"
                            id="dataTable"
                            width="100%"
                            cellspacing="0"
                          >
                            <thead>
                              <tr>
                                <th><input type="checkbox" name={`select_all`} id={`select_all`} value={'Y'} className="form-check-input"/> Sl. No.</th>
                                <th>Products</th>
                                <th>Points</th>
                                <th>Stock</th>
                                <th colSpan={2}>Action</th>
                              </tr>
                            </thead> 
                            <tbody>
                              {transformData?.length > 0 ? (
                                transformData.map((items, index) => (
                                  <>
                                    <tr key={index} htmlFor={`variant___${items._id}`}>
                                      <td>
                                        <input type="checkbox" name={`variant___${items._id}`} id={`variant___${items._id}`} value={'Y'} checked={items?.select === 'Y'?true:false} className="form-check-input"/>
                                        {" "}{index + 1}
                                      </td>
                                      <td>{`${items?.product_name} || ${items?.unit}`}</td>
                                      <td className="admin_user_list_date">{items?.price.toFixed(2)}</td>
                                      <td className="admin_user_list_date">{items?.stock}</td>
                                      <td className="admin_user_list_date">
                                        {items.select === 'N' ? (
                                          (PERMISSION?.fullAccess === 'Y' || PERMISSION?.addRemove === 'Y') && (
                                            <Link to={false} className="all_lable_for_vendor_dashbaord" onClick={()=>handleAddInventory(items)} > <FontAwesomeIcon icon={faAdd}/> Add </Link>
                                          )
                                          ) : (
                                            (PERMISSION?.fullAccess === 'Y' || PERMISSION?.addRemove === 'Y') && (
                                              <Link to={false} className="all_lable_for_vendor_dashbaord" onClick={()=>handleDeleteInventory(items?.inventory_id)} > <FontAwesomeIcon icon={faTrash} /> Remove </Link>
                                            )
                                          )
                                        }
                                      </td>
                                      <td className="admin_user_list_date">
                                      {(items.select === 'Y' || (PERMISSION?.fullAccess === 'Y' || PERMISSION?.updateStock === 'Y')) && (
                                        <Link to={false} className="all_lable_for_vendor_dashbaord" onClick={()=>handleUpdateStock(items?.inventory_id)}> <FontAwesomeIcon icon={faEdit}/> Stock </Link>
                                      )}
                                      </td>
                                    </tr>
                                  </>
                                ))
                              ) : isLoading ? <SkeltonList row={5} col={8} /> : <tr> 
                                  <td colspan="11" className="img-center" >No data found !</td> 
                              </tr>}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <LoadingEffect isLoading={isLoading} />
      <UpdateStock popUpOpen={updateStock} togglePopUp={toggleUpdateStock} process={handleUpdateStock} />
    </div>
  );
};

export default AddEditInventoryData;
